import React from "react"

import TileCarousel from "@components/TileCarousel/TileCarousel"
import ArticleCarouselItem from "./ArticleCarouselItem"
import { Box } from "@chakra-ui/react"

export interface FeaturedArticlesCarouselProps {
  items: NormalisedArticle[]
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  handleTrackingClick: VoidFunction
  hideBadges?: boolean
}

const FeaturedArticlesCarousel = ({ items, carouselSettings, handleTrackingClick, hideBadges }: FeaturedArticlesCarouselProps) => (
  <Box
    sx={{
      ".swiper": {
        overflow: "visible",
      },
    }}
  >
    <TileCarousel carouselSettings={carouselSettings} spaceBetweenTiles={16} slidesPerView={4.15} slidesPerViewMobile={1.15}>
      {items?.map(item => <ArticleCarouselItem key={item?.key} item={item} handleTrackingClick={handleTrackingClick} hideBadges={hideBadges} />)}
    </TileCarousel>
  </Box>
)

export default FeaturedArticlesCarousel
